import { useQuery } from '@tanstack/react-query';
import { RectangleStackIcon } from '@heroicons/react/24/outline';
import { Card } from '@/components/ui/Card';
import EmptyState from '@/components/ui/EmptyState';
import { Table, THead, TBody, TR, TH, TD } from '@/components/ui/Table';
import { getCycleUsage } from '@/api/cyclesService';
import { queryKeys } from '@/lib/queryKeys';

const CycleUsageTab = ({ cycleId }: { cycleId: string }) => {
  const { data, isLoading } = useQuery({
    queryKey: queryKeys.pv2CycleUsage(cycleId),
    queryFn: () => getCycleUsage(cycleId),
    enabled: Boolean(cycleId),
  });

  if (isLoading) return <p className="text-sm text-gray-500">Chargement…</p>;

  const plans = data?.plans ?? [];

  if (plans.length === 0) {
    return (
      <EmptyState
        icon={<RectangleStackIcon />}
        title="Aucun plan n’utilise ce cycle"
        description="Les plans qui référencent ce cycle apparaîtront ici."
      />
    );
  }

  return (
    <Card className="p-0">
      <Table>
        <THead>
          <tr>
            <TH>Plan</TH>
            <TH>Position</TH>
            <TH>Semaines</TH>
          </tr>
        </THead>
        <TBody>
          {plans.map((plan) => (
            <TR key={`${plan.id}-${plan.orderIndex}`}>
              <TD className="font-medium text-gray-900 dark:text-gray-100">{plan.name}</TD>
              <TD className="text-gray-500">#{plan.orderIndex + 1}</TD>
              <TD className="text-gray-500">{plan.weekCount} sem.</TD>
            </TR>
          ))}
        </TBody>
      </Table>
    </Card>
  );
};

export default CycleUsageTab;
